import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { ErrorService } from '../service/error.service';
import { AuthenticationService } from '../service/authentication.service';
import { finalize, map, catchError } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

@Injectable()
export class CustomerhttpInterceptor implements HttpInterceptor {

  constructor(
        private router: Router,
        private authService: AuthenticationService,
        private errorService: ErrorService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
          "Accept": "application/json"
      },
  });

  return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
          if (error.status == 401 || error.status == 402 || error.status == 403) {
              this.errorService.addErrors(["登入已過期，請重新登入", "3秒後將自動導到登入頁面..."]);
              setTimeout(() => {
                  this.router.navigate(['/liff']);
                  this.errorService.removeErrors();
              }, 3000);
          } else if(error.status == 500){
              this.errorService.addErrors(["伺服器發生錯誤，請稍後再試", "3秒後將自動導到首頁..."]);
              setTimeout(() => {
                  this.router.navigate(['/']);
                  this.errorService.removeErrors();
              }, 3000);
          }

          return throwError(error.error);;
      }),
  );
  }
}
